import { Routes } from '@angular/router';
import { ProductsComponent } from './products/products.component';
import { ProductDetailsComponent } from './product-details/product-details.component';

export const ProductRoutingModule: Routes = [
	{ path: 'products', component: ProductsComponent },
	{ path: 'products/:id', component: ProductDetailsComponent },
	// { path: 'add-product', component: AddProductComponent },
];
